var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1389_23072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.7941 4.79866L9.04588 1.45827C9.37109 1.1242 9.37109 0.584622 9.04588 0.250552C8.72068 -0.0835174 8.17044 -0.0835174 7.8702 0.250552L4.61842 3.61669C4.29321 3.95076 4.29321 4.51599 4.61842 4.82441C4.91865 5.1327 5.46901 5.15848 5.7941 4.79874V4.79866Z",
    fill: "#E0499B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7208 9.03876C9.04601 9.37283 9.57128 9.37283 9.89648 9.03876L13.1733 5.67263C13.4985 5.33856 13.4985 4.79898 13.1733 4.46491C12.8481 4.13084 12.2979 4.13084 11.9976 4.46491L8.74586 7.83104C8.37065 8.16511 8.39565 8.70469 8.72087 9.03876H8.7208Z",
    fill: "#E0499B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.11914 5.20968L8.34545 7.49665C8.34545 7.47098 8.37044 7.47098 8.37044 7.47098L11.6473 4.10484L9.42097 1.81787L6.14413 5.18401C6.14413 5.18401 6.11914 5.18401 6.11914 5.20968Z",
    fill: "#FDF41B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.26928 6.08301L0.340891 11.8389C-0.109376 12.2758 -0.109376 12.9953 0.315901 13.432C0.766168 13.8946 1.46658 13.8689 1.86676 13.4064L7.46997 7.29068L6.26928 6.08301Z",
    fill: "#FDF41B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99503 13.0703V13.5329H7.64482C7.24464 13.5329 6.91943 13.867 6.91943 14.278V14.9462H15.4994V14.278C15.4994 13.867 15.1742 13.5329 14.774 13.5329H14.4238V13.0703C14.4238 12.6593 14.0986 12.3252 13.6984 12.3252H8.72047C8.3203 12.3252 7.99503 12.6591 7.99503 13.0703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7496 15.4858H6.61927C6.46922 15.4858 6.36914 15.5886 6.36914 15.7428C6.36914 15.8969 6.46921 15.9997 6.61927 15.9997H15.7496C15.8997 15.9997 15.9998 15.8969 15.9998 15.7428C15.9998 15.5886 15.8997 15.4858 15.7496 15.4858Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1389_23072"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMint);
export default __webpack_public_path__ + "static/media/mint.7a3a24e412dbb70027dd6ef64dabc120.svg";
export { ForwardRef as ReactComponent };